import { Flex } from 'ui/Layout';
import { Text } from 'ui/Typography';

import { websiteLinkTo } from '../../utils/routes';
import FooterLink from './FooterLink';

const PageFooter: React.FC = () => (
  <Flex
    as="footer"
    alignItems="center"
    background="gray.50"
    borderTop="1px solid"
    borderTopColor="gray.200"
    color="gray.500"
    flexDirection={{ base: 'column', sm: 'row' }}
    gap={3}
    justifyContent="center"
    p={2}
  >
    <FooterLink
      label={`SankeyArt © ${new Date().getFullYear()}`}
      href={websiteLinkTo('/imprint/')}
    />
    <Text display={{ base: 'none', sm: 'block' }}>·</Text>
    <Flex gap={3}>
      <FooterLink label="Features" href={websiteLinkTo('/features/')} />
      <FooterLink label="Terms" href={websiteLinkTo('/terms/')} />
      <FooterLink label="Privacy" href={websiteLinkTo('/privacy/')} />
      <FooterLink label="Imprint" href={websiteLinkTo('/imprint/')} />
      <FooterLink label="Blog" href={websiteLinkTo('/content/blog/')} />
      <FooterLink label="Pricing" href={websiteLinkTo('/pricing/')} />
      <FooterLink label="FAQ" href={websiteLinkTo('/faq/')} />
    </Flex>
  </Flex>
);

export default PageFooter;
